module.exports = __webpack_public_path__ + "resources/img/img-zenius-ems-01.40eaa6471ee9cfc1b963f20cb0585936.png";